<div class="container-antecedentes-pension">
  <app-boton-volver (clickVolver)="goBack()"></app-boton-volver>

  <h1 class="title-section title">Solicitud de Pensión por Vejez</h1>
  <p class="sub-title mt16">Responde las siguientes preguntas para continuar</p>

  <h2 class="mt24 sub-title-antecedentes">Antecedentes de pensión</h2>
  <p class="sub-title mt8">Selecciona una opción</p>

  <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="isFormReady">

    <app-preguntas *ngFor="let q of questions | slice:0:visibleQuestionsCount; let i = index" [question]="q"
      [index]="i + 1" [total]="questions.length" [form]="form" [isActive]="activeQuestionIndex === i"
      [resumenRefreshToken]="resumenRefreshToken"
      (requestToggle)="$event ? openQuestion(i) : closeQuestion()"
      (saveAmount)="onSaveAmount()">
    </app-preguntas>

    <!-- CONFIRM -->

    <div class="confirmacion mt32" *ngIf="visibleQuestionsCount === questions.length && form.valid">
      <div class="info-check">
        <div class="info-check__check">
          <ion-checkbox slot="start" formControlName="confirm" (keydown)="onCheckboxKeydown($event)">
          </ion-checkbox>
        </div>
        <ion-label class="label-check">
          Confirmo que he actualizado mis Antecedentes de pensión.
        </ion-label>
      </div>
    </div>

    <div class="div-btn-continuar mt24" *ngIf="visibleQuestionsCount === questions.length && form.valid">
      <!-- BUTTON -->
      <button type="submit" class="primary-button" [disabled]="!canContinue()">
        Continuar
      </button>
    </div>
  </form>
</div>